import React, { useRef } from "react";
import useMeasure from "react-use-measure";
import { mergeRefs } from "react-merge-refs";

import { useAppContext } from "../helpers/account-context";
import RadiusSelector from "./Filters/RadiusSelector";
import TagSelector from "./Filters/TagSelector";
import TypeSelector from "./Filters/TypeSelector";

const FilterDialog = (props) => {
  const { getLocale } = useAppContext()
  const { filters, onChangeFilters, onApplyFilters, isOpen, onClose, filterType } = props;
  // https://codepen.io/smithsuth/pen/VvYzZP

  const [containerRef, containerBounds] = useMeasure();
  const [innerRef, innerBounds] = useMeasure();
  const wrapperRef = useRef();
  const contentRef = useRef();
  const handleApplyFilter = (e) => {
    e.preventDefault();
    onApplyFilters(filters);
  };

  const isScrollable =
    containerBounds &&
    innerBounds &&
    containerBounds.height < contentRef.current?.scrollHeight;
  const showLocationType = filterType !== 'radius'
  const showTags = filterType !== 'radius'
  const showRadius = filterType !== 'tags'

  return (

        <div
          className={`cbmap-dialog cbmap-filter-dialog ${
            isOpen ? "cbmap-visible" : "cbmap-invisible"
          }`}
        >        
          <div className="cbmap-header">
            <div className="cbmap-header-inner">
              <div className="cbmap-header-title">{getLocale("filters")}</div>
              <div className="cbmap-header-buttons">
                <button className="cbmap-btn cbmap-btn-outline cbmap-btn-cancel"
                  title={getLocale("close")}
                  onClick={onClose}
                >
                  {getLocale("close")}
                </button>
              <button className="cbmap-btn cbmap-btn-primary cbmap-btn-apply"
                onClick={handleApplyFilter}
              >
               {getLocale("apply")}
              </button>
              </div>
            </div>
          </div>
          <div
            ref={mergeRefs([wrapperRef, containerRef])}
            className={`cbmap-body cbmap-scrollable ${
              isOpen ? "cbmap-visible" : "cbmap-invisible"
            }
              ${isScrollable ? "cbmap-overheight" : ""}
            `}
          >
            <div className="cbmap-filter-body" ref={mergeRefs([contentRef,innerRef])}>
              {
                showLocationType && <TypeSelector
                filters={filters}
                onChangeFilters={onChangeFilters}
              />
              }
              {
                showTags &&  <TagSelector
                filters={filters}
                onChangeFilters={onChangeFilters}
              />
              }
              {
                showRadius && <RadiusSelector
                filters={filters}
                onChangeFilters={onChangeFilters}
              />
              }
             
             
            </div>
          </div>
        </div>     
  );
};

export default FilterDialog;
